var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyAnggota(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3335 71.3333H76.6668V66C76.6668 61.5817 73.0851 58 68.6668 58C66.1185 58 63.8485 59.1914 62.3835 61.0477M63.3335 71.3333H36.6668M63.3335 71.3333V66C63.3335 64.25 62.9964 62.5788 62.3835 61.0477M36.6668 71.3333H23.3335V66C23.3335 61.5817 26.9152 58 31.3335 58C33.8818 58 36.1518 59.1914 37.6168 61.0477M36.6668 71.3333V66C36.6668 64.25 37.004 62.5788 37.6168 61.0477M37.6168 61.0477C39.5828 56.136 44.3863 52.6666 50.0002 52.6666C55.614 52.6666 60.4175 56.136 62.3835 61.0477M58.0002 36.6666C58.0002 41.0849 54.4184 44.6666 50.0002 44.6666C45.5819 44.6666 42.0002 41.0849 42.0002 36.6666C42.0002 32.2483 45.5819 28.6666 50.0002 28.6666C54.4184 28.6666 58.0002 32.2483 58.0002 36.6666ZM74.0002 44.6666C74.0002 47.6121 71.6123 50 68.6668 50C65.7213 50 63.3335 47.6121 63.3335 44.6666C63.3335 41.7211 65.7213 39.3333 68.6668 39.3333C71.6123 39.3333 74.0002 41.7211 74.0002 44.6666ZM36.6668 44.6666C36.6668 47.6121 34.279 50 31.3335 50C28.388 50 26.0002 47.6121 26.0002 44.6666C26.0002 41.7211 28.388 39.3333 31.3335 39.3333C34.279 39.3333 36.6668 41.7211 36.6668 44.6666Z",
    stroke: "#667085",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAnggota);
export default __webpack_public_path__ + "static/media/empty-anggota.ae9d17961d31a3ff5f798160a967bcc5.svg";
export { ForwardRef as ReactComponent };